import Vue from 'vue'
import Router from 'vue-router'

import Documents from "./views/Documents";
import Login from './views/Login.vue'
import Pipelines from "./views/Pipelines";
import Status from "./views/Status";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: "/documents",
      name: 'documents',
      component: Documents,
      params: {ordering:[],status:[]}
    },
    {
      path: "/pipelines",
      name: 'pipelines',
      component: Pipelines,
    },
    {
      path: "/",
      name: 'status',
      component: Status,
    }
  ]
})
